"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext } from "react";
export function FilterPanelContainer(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const {
    Container
  } = useContext(FilterPanelContainerContext);
  if (Container) {
    let t1;
    if ($[0] !== Container || $[1] !== children) {
      t1 = <Container>{children}</Container>;
      $[0] = Container;
      $[1] = children;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  return children;
}
const FilterPanelContainerContext = createContext({
  Container: undefined
});
export const FilterPanelContainerProvider = FilterPanelContainerContext.Provider;